import { render } from "./MmChangePassword.vue?vue&type=template&id=07eef35a"
import script from "./MmChangePassword.vue?vue&type=script&lang=js"
export * from "./MmChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__